export default __webpack_public_path__ + "static/media/arrow-up-small-footer.41b7a230.svg";